import { FETCH_APP_TOKEN_REQUEST, FETCH_APP_TOKEN_SUCCESS, FETCH_APP_TOKEN_FAILURE, CLEAR_APP_TOKEN } from '../constants/token'
import { clear } from "redux-localstorage-simple"

const defaultTokenState = {
  accessToken: '',
  loginSuccess: false,
  loginFailure: false,
  pending: false,
  signedIn: false
}

export default (state = defaultTokenState, action) => {

  var newState = {...state}

  switch (action.type){
    case FETCH_APP_TOKEN_SUCCESS:
      newState.accessToken = action.body.access_token;
      newState.loginSuccess = true;
      newState.pending = false;
      newState.signedIn = true;
      return newState;
    case FETCH_APP_TOKEN_REQUEST:
      newState.pending = true;
      return newState;
    case CLEAR_APP_TOKEN:
      newState = defaultTokenState;
      clear(); //Clears the Redux LocalStorage
      return newState;
    case FETCH_APP_TOKEN_FAILURE:
      newState.loginFailure = true;
      newState.pending = false;
      return newState;
    default:  return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/token.js